import { formModes, documentStatuses, certificationKinds, deliveryPlaces } from '../../../constants.js';
import { getCertificationPeriodErrorText } from '../DocumentHelpers.js';

export default {
    updateFields(documentData, context) {
        const { userContext, formMode } = context;

        const kindField = documentData.form.fields.find(f => f.name === 'sx:dfDocKind');
        let kindVal = documentData.properties['sx:dfDocKind'];

        if (!userContext.isHead && formMode !== formModes.read) {
            kindField.values.data = kindField.values.data.filter(item => item.value !== certificationKinds.characteristic);
            if (kindVal === certificationKinds.characteristic) {
                documentData.properties['sx:dfDocKind'] = kindField.values.data[0].value;
                kindVal = kindField.values.data[0].value;
            }
        }

        const isSubordinateField = documentData.form.fields.find(f => f.name === 'sx:ctCertificationForSubordinate');
        if (kindVal === certificationKinds.characteristic) {
            isSubordinateField.disabled = true;
            documentData.properties['sx:ctCertificationForSubordinate'] = true;
        }
        else if (formMode !== formModes.read) {
            isSubordinateField.disabled = false;
        }
        if (!userContext.isHead && (formMode === formModes.create || documentData.properties['sx:dfState'] === documentStatuses.template)) {
            isSubordinateField.visible = false;
        }
        else {
            isSubordinateField.visible = true;
        }

        const subordinateUserField = documentData.form.fields.find(f => f.name === 'assoc:sx:ctSubordinate_added');
        const subordinateUserFieldCreateMode = documentData.form.fields.find(f => f.name === 'sx:ctSubordinate');
        const isSubordinateVal = documentData.properties['sx:ctCertificationForSubordinate'];
        if (subordinateUserField) subordinateUserField.visible = isSubordinateVal;
        if (subordinateUserFieldCreateMode) subordinateUserFieldCreateMode.visible = isSubordinateVal;

        const deliveryPlaceField = documentData.form.fields.find(f => f.name === 'sx:ctDeliveryPlace');
        deliveryPlaceField.visible = documentData.properties['sx:ctPaperVersion'];

        const deliveryPlaceValue = documentData.properties['sx:ctDeliveryPlace']

        const addressField = documentData.form.fields.find(f => f.name === 'sx:ctAddress');
        const branchNumberField = documentData.form.fields.find(f => f.name === 'sx:ctBranchNumber');
        const phoneNumberField = documentData.form.fields.find(f => f.name === 'sx:ctNumber');
        const pointLocationField = documentData.form.fields.find(f => f.name === 'sx:ctPointLocation');

        const upAddressField = documentData.form.fields.find(f => f.name === 'sx:ctIndex');
        const upPhoneNumberField = documentData.form.fields.find(f => f.name === 'sx:ctNumberU');

        addressField.visible = branchNumberField.visible = phoneNumberField.visible = deliveryPlaceField.visible && deliveryPlaceValue === deliveryPlaces.np;
        pointLocationField.visible = deliveryPlaceField.visible && deliveryPlaceValue === deliveryPlaces.tt;
        upAddressField.visible = upPhoneNumberField.visible = deliveryPlaceField.visible && deliveryPlaceValue === deliveryPlaces.ukrPost;


        const periodFromMonthField = documentData.form.fields.find(f => f.name === 'sx:ctMonth');
        const periodFromYearField = documentData.form.fields.find(f => f.name === 'sx:ctYearFrom');
        const periodToMonthField = documentData.form.fields.find(f => f.name === 'sx:ctMonthTo');
        const periodToYearField = documentData.form.fields.find(f => f.name === 'sx:ctYearTo');

        periodToYearField.errorText = getCertificationPeriodErrorText(documentData);


        const purposeField = documentData.form.fields.find(f => f.name === 'sx:ctcertificationPurpose');
        periodFromMonthField.visible = periodFromYearField.visible = periodToMonthField.visible = periodToYearField.visible =
            purposeField.visible = kindVal === certificationKinds.incomeCertificate;

        const commentField = documentData.form.fields.find(f => f.name === 'sx:claimComment');
        commentField.visible = kindVal === certificationKinds.incomeCertificate;

        const goalDescriptionField = documentData.form.fields.find(f => f.name === 'sx:ctGoalsDescription');
        goalDescriptionField.visible = kindVal === certificationKinds.other;

        const rejectCommentField = documentData.form.fields.find(f => f.name === 'sx:rejectcomment');
        rejectCommentField.visible = documentData.properties['sx:dfState'] === documentStatuses.enteringInfo && documentData.properties['sx:rejectcomment'];

        const mainContentField = documentData.form.fields.find(f => f.name === 'cm:content');
        if (mainContentField) mainContentField.visible = kindVal === certificationKinds.characteristic && formMode !== formModes.read;

        if (documentData.properties['sx:dfState'] === documentStatuses.enteringInfo && formMode !== formModes.read) {
            const notDisabledFields = ['sx:claimComment', 'sx:ctGoalsDescription', 'sx:ctPaperVersion', 'sx:ctDeliveryPlace', 'sx:ctAddress', 'sx:ctBranchNumber', 'sx:ctNumber', 'sx:ctPointLocation', 'sx:ctIndex', 'sx:ctNumberU'];
            documentData.form.fields.forEach(f => {
                if (!notDisabledFields.includes(f.name)) {
                    f.disabled = true;
                }
            });
        }
    },

    checkInputPage(documentData, context) {
        let result = true;
        let errorElementName = '';
        let errorElementId = '';
        let nIndex = 0;

        const { formMode, mainContent } = context;

        const kindVal = documentData.properties['sx:dfDocKind'];

        if (result && !kindVal) {
            result = false;
            errorElementName = "sx:dfDocKind";
        }
        if (result) {
            switch (kindVal) {
                case certificationKinds.other:
                    if (!documentData.properties["sx:ctGoalsDescription"]) {
                        result = false;
                        errorElementName = "sx:ctGoalsDescription";
                    }
                    break;
                case certificationKinds.incomeCertificate:
                    if (result && !documentData.properties["sx:ctMonth"]) {
                        result = false;
                        errorElementName = "sx:ctMonth";
                    }
                    if (result && !documentData.properties["sx:ctYearFrom"]) {
                        result = false;
                        errorElementName = "sx:ctYearFrom";
                    }
                    if (result && !documentData.properties["sx:ctMonthTo"]) {
                        result = false;
                        errorElementName = "sx:ctMonthTo";
                    }
                    if (result && !documentData.properties["sx:ctYearTo"]) {
                        result = false;
                        errorElementName = "sx:ctYearTo";
                    }
                    if (result && getCertificationPeriodErrorText(documentData)) {
                        result = false;
                        errorElementName = "sx:ctYearTo";
                        break;
                    }
                    if (result && !documentData.properties["sx:ctcertificationPurpose"]) {
                        result = false;
                        errorElementName = "sx:ctcertificationPurpose";
                    }
                    break;
            }
        }
        if (documentData.properties["sx:ctCertificationForSubordinate"]) {
            if (result && formMode === formModes.create && !documentData.properties["sx:ctSubordinate"]) {
                result = false;
                errorElementName = "sx:ctSubordinate";
            }
            if (result && formMode !== formModes.create && !documentData.properties["assoc:sx:ctSubordinate_added"]) {
                errorElementName = "assoc:sx:ctSubordinate_added";
                result = false;
            }
        }
        if (result && kindVal === certificationKinds.characteristic) {
            if ((!documentData.associations?.mainContent || documentData.associations.mainContent.length <= 0) && !mainContent) {
                result = false;
                errorElementName = "cm:content";
            }
        }
        if (result && documentData.properties["sx:ctPaperVersion"]) {
            if (!documentData.properties["sx:ctDeliveryPlace"]) {
                result = false;
                errorElementName = "sx:ctDeliveryPlace";
            }
            else {
                switch (documentData.properties["sx:ctDeliveryPlace"]) {
                    case deliveryPlaces.ukrPost:
                        if (!documentData.properties["sx:ctIndex"]) {
                            result = false;
                            errorElementName = "sx:ctIndex";
                        }
                        else if (!documentData.properties["sx:ctNumberU"]) {
                            result = false;
                            errorElementName = "sx:ctNumberU";
                        }
                        break;
                    case deliveryPlaces.np:
                        if (!documentData.properties["sx:ctAddress"]) {
                            result = false;
                            errorElementName = "sx:ctAddress";
                        }
                        else if (!documentData.properties["sx:ctBranchNumber"]) {
                            result = false;
                            errorElementName = "sx:ctBranchNumber";
                        }
                        else if (!documentData.properties["sx:ctNumber"]) {
                            result = false;
                            errorElementName = "sx:ctNumber";
                        }
                        break;
                    case deliveryPlaces.tt:
                        if (!documentData.properties["sx:ctPointLocation"]) {
                            result = false;
                            errorElementName = "sx:ctPointLocation";
                        }
                        break;
                }
            }
        }

        return {
            result,
            errorElementName,
            errorElementId,
            nIndex
        };
    }
}